import styled, { css, createGlobalStyle } from 'styled-components'
import { MENU_OPEN_CSS_CLASS, TRANSITION_MS_IN, TRANSITION_MS_OUT } from './constants'

export const globalStyles = css`
  .${MENU_OPEN_CSS_CLASS},
  .${MENU_OPEN_CSS_CLASS} body {
    overflow: hidden;
    height: 100%;
  }
`

export const GlobalStyle = createGlobalStyle<any>`
  ${globalStyles}
  ${props => props.scrollTop && `
    #root {
      transform: translateY(-${props.scrollTop}px)
    }
  `}
`

export const Lateral = styled.div<any>`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 101;
  pointer-events: none;
  ${props => props.isVisible && `
    pointer-events: auto;
  `}
`

export const Menu = styled.div<any>`
  position: relative;
  height: 100%;
  width: 80%;
  max-width: 400px;
  background: ${props => props.theme.palette.general.light};
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
  pointer-events: auto;
  transform: translateX(-103%);
  transition: transform ${TRANSITION_MS_OUT}ms ease-out;
  will-change: transform;
  z-index: 20;
  ${props => props.isVisible && `
    transform: none;
    transition: transform ${TRANSITION_MS_IN}ms ease-in;
  `}
`

export const Overlay = styled.div<any>`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  opacity: 0;
  will-change: opacity;
  transition: opacity 300ms 0ms;
  pointer-events: none;
  ${props => props.isVisible && `
    opacity: 1;
    pointer-events: auto;
  `}
`
